export const environment = {
  production: false,
  defaultauth: 'localhost',
  backend: 'https://api.nikki-staging.nl/api/',
  backend_web: 'https://api.nikki-staging.nl/',
  env: 'staging',
  name: 'NIKKI',
  locale: "en",
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "" 
  }
};